import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import JitsiCall from "@/components/JitsiCall";
import { Button } from "@/components/ui/button";
import { Activity, PhoneOff } from "lucide-react";

export default function Teleconsulta() {
  const { room } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const name = params.get("nome") || (params.get("host") === "1" ? "Médico(a)" : "Paciente");

  return (
    <div className="min-h-screen flex flex-col bg-neutral-950">
      <header className="flex items-center justify-between px-5 py-3 bg-primary text-primary-foreground">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary-foreground/15 flex items-center justify-center">
            <Activity className="w-4 h-4" strokeWidth={2.5} />
          </div>
          <div>
            <p className="font-heading font-extrabold leading-none text-sm">LIA <span className="text-ai">Teleconsulta</span></p>
            <p className="text-[11px] text-primary-foreground/70">Atendimento por vídeo · seguro</p>
          </div>
        </div>
        <Button variant="ghost" size="sm" data-testid="tele-leave-btn"
          className="text-primary-foreground/80 hover:text-primary-foreground hover:bg-primary-foreground/10"
          onClick={() => navigate("/")}>
          <PhoneOff className="w-4 h-4 mr-2" /> Sair
        </Button>
      </header>
      <div className="flex-1 min-h-0" data-testid="teleconsulta-page">
        <JitsiCall room={room} displayName={name} onEnded={() => navigate("/")} />
      </div>
    </div>
  );
}
